import { useState } from "react";
import { useDispatch } from "react-redux";
import {
    fetchMemberBalance,
    updateMemberWithdrawalRequest,
    updateSavingsWithdrawalRequest,

} from "../../store/actions/adminActions";
import Swal from "sweetalert2";

export function useWithdrawalActions(type) {
    const dispatch = useDispatch();

    const [selectedRequest, setSelectedRequest] = useState(null);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [showCommentsModal, setShowCommentsModal] = useState(false);
    const [processingAction, setProcessingAction] = useState(false);
    const [comments, setComments] = useState("");
    const [transactionReference, setTransactionReference] = useState("");

    const handleViewDetails = (request) => {


        setSelectedRequest(request);

        if (request.memberId) {
            dispatch(fetchMemberBalance(request.memberId));
        }

        setShowDetailsModal(true);
    };

    const handleUpdateStatus = (status) => {
        if (status === "rejected" && !comments.trim()) {
            setShowCommentsModal(true);
            return;
        }

        updateRequestStatus(status);
    };

    const updateRequestStatus = (status) => {
        setProcessingAction(true);

        const updateData = {
            status,
            comments: comments || undefined
        };

        // If processing a request with individual items
        if (selectedRequest.withdrawalRequests) {
            updateData.withdrawalRequests = selectedRequest.withdrawalRequests.map(item => ({
                ...item,
                status: status
            }));
        }

        // If marking as processed, add transaction reference
        if (status === "processed") {
            updateData.transactionReference = transactionReference;
        }

        const requestId = selectedRequest._id;
        const actionCreator = type === "savings"
            ? updateSavingsWithdrawalRequest
            : updateMemberWithdrawalRequest;

        dispatch(actionCreator({ requestId, updateData }))
            .then(() => {
                Swal.fire({
                    icon: "success",
                    title: `Request ${status.charAt(0).toUpperCase() + status.slice(1)}`,
                    text: `The withdrawal request has been ${status}.`
                });
                setShowDetailsModal(false);
                setShowCommentsModal(false);
                setComments("");
                setTransactionReference("");
            })
            .catch(error => {
                Swal.fire({
                    icon: "error",
                    title: "Update Failed",
                    text: error.message || "Failed to update withdrawal request"
                });
            })
            .finally(() => {
                setProcessingAction(false);
            });
    };

    const closeModals = () => {
        setShowDetailsModal(false);
        setShowCommentsModal(false);
        setComments("");
        setTransactionReference("");
    };

    return {
        selectedRequest,
        showDetailsModal,
        showCommentsModal,
        processingAction,
        setProcessingAction,
        comments,
        transactionReference,
        setSelectedRequest,
        setShowDetailsModal,
        setShowCommentsModal,
        setComments,
        setTransactionReference,
        handleViewDetails,
        handleUpdateStatus,
        closeModals
    };
}
